import React, { useState } from 'react';
import { AiFillEye, AiFillEyeInvisible } from 'react-icons/ai';
import { BiLogInCircle } from 'react-icons/bi';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { Button, Input } from '../components/Form';
import * as actionCreators from '../store/actions/index';

const Login = (props) => {
  const [formState, setFormState] = useState({
    formIsValid: false,
    username: '',
    password: '',
    passwordError: '',
    showPasswordError: false,
  });
  const [passwordVisible, setPasswordVisible] = useState(false);
  const navigate = useNavigate();

  const inputChangedHandler = (event, field) => {
    setFormState((prevState) => ({
      ...prevState,
      [field]: event.target.value,
    }));
  };

  const submitHandler = (event) => {
    event.preventDefault();
    const formData = {
      email: formState.username,
      password: formState.password,
    };

    if (formState.password) {
      props.onAuth(formData, navigate);
    } else {
      setFormState((prevState) => ({
        ...prevState,
        passwordError: 'Please enter the password',
        showPasswordError: true,
      }));
    }
  };

  return (
    <div className="flex h-screen w-full bg-white p-[60px]">
      {/* Left Section: Login Panel (50%) */}
      <div className="flex h-full w-1/2 items-center justify-center">
        <div className="w-full max-w-md rounded-lg bg-blue-50 p-10 shadow-lg">
          <form className="flex w-full flex-col">
            <img
              src="/images/rdxlogo.png"
              alt="logo"
              className="mb-6 h-16 w-48 object-contain"
            />
            <div className="mb-6 flex w-full flex-col gap-6">
              <Input
                label="Email"
                color={true}
                className="rounded-lg border border-blue-200 p-3 text-gray-800"
                placeholder="doctor@example.com"
                value={formState.username}
                onChange={(event) => inputChangedHandler(event, 'username')}
              />
              <div className="relative w-full">
                <Input
                  label="Password"
                  type={passwordVisible ? 'text' : 'password'}
                  color={true}
                  className="rounded-lg border border-blue-200 p-3 text-gray-800"
                  placeholder="********"
                  value={formState.password}
                  onChange={(event) => inputChangedHandler(event, 'password')}
                />
                <div
                  className="absolute right-4 top-1/2 -translate-y-1/2 cursor-pointer text-gray-500"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                >
                  {passwordVisible ? (
                    <AiFillEye size={24} />
                  ) : (
                    <AiFillEyeInvisible size={24} />
                  )}
                </div>
              </div>
              {formState.showPasswordError && (
                <div className="text-sm text-red-500">
                  {formState.passwordError}
                </div>
              )}
            </div>
            <Button
              label="Login"
              Icon={BiLogInCircle}
              className="bg-blue-600 text-white hover:bg-blue-700 focus:ring-2 focus:ring-blue-500"
              onClick={submitHandler}
            />
            <div className="mt-4 text-left">
              <span
                className="cursor-pointer text-blue-600 hover:underline"
                onClick={() => navigate('/signup')}
              >
                New here? Create an account
              </span>
            </div>
          </form>
        </div>
      </div>

      {/* Right Section: Info Panel (50%) */}
      <div className="flex h-full w-1/2 flex-col items-center justify-start pt-[140px]">
        <h1 className="mb-8 text-center text-5xl font-bold text-gray-800">
          Your Partner in
          <br />
          <span className="text-blue-900">Rare Disease Diagnosis!</span>
        </h1>
        <p className="mt-[-10px] w-full text-center text-lg text-gray-700">
          We provide cutting-edge technology and expertise to assist in
          diagnosing rare diseases with precision and care. Trust us to be your
          guide on the journey to better health.
        </p>
        <div className="mt-6 flex w-full items-center justify-center">
          <img
            src="/images/logo.png"
            alt="logo"
            className="mb-6 h-12 w-36 object-contain"
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  loading: state.login.loading,
});

const mapDispatchToProps = (dispatch) => ({
  onAuth: (formData, navigate) =>
    dispatch(actionCreators.auth(formData, navigate)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Login);
